import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

export const areSearchResultsPropsEqual = <Props extends object>(
	previousProps: Readonly<Props>,
	nextProps: Readonly<Props>,
): boolean => {
	if (!isExperimentEnabled('rovo_fps_memoize_search_results')) {
		return false;
	}

	const previousKeys = Object.keys(previousProps) as (keyof Props)[];
	const nextKeys = Object.keys(nextProps);

	return (
		previousKeys.length === nextKeys.length &&
		previousKeys.every(
			(key) =>
				Object.prototype.hasOwnProperty.call(nextProps, key) &&
				Object.is(previousProps[key], nextProps[key]),
		)
	);
};
